<template>
  <div>
    <NavBar :index="3" />
    <div>
      <div class="title-img" id="job">
        <img
          style="width: 350px; height: 100px"
          src="@/assets/img/label-post.png"
          alt=""
        />
      </div>
      <div class="job-box">
        <div v-if="jobList.length">
          <el-collapse
            v-model="activeNames"
            style="width: 80vw; margin: 0 10vw"
          >
            <el-collapse-item
              title="Consistency"
              :name="index"
              v-for="(item, index) in jobList"
              :key="index"
            >
              <template #title>
                <span
                  style="
                    flex: 1;
                    text-align: left;
                    font-size: 20px;
                    color: black;
                  "
                  >{{ item.name }}</span
                >
                <div
                  style="
                    display: inline-block;
                    margin: 0 15px;
                    font-size: 14px;
                    color: #666;
                    align-self: center;
                  "
                >
                  查看详情
                </div>
                <div
                  style="
                    display: inline-block;
                    background-color: rgba(35, 110, 235, 1);
                    color: #fff;
                    height: 30px;
                    line-height: 30px;
                    padding: 0 12px;
                    font-size: 16px;
                    border-radius: 6px;
                    cursor: pointer;
                  "
                  @click.stop="show(index)"
                >
                  立即申请
                </div>
              </template>
              <template #icon></template>
              <div style="text-align: left; padding: 0 20px; line-height: 30px">
                <div style="display: flex">
                  <div style="display: inline-block; width: 40vw">
                    <span class="fw9">岗位类型：</span>{{ item.positionsType }}
                  </div>
                  <div style="">
                    <span class="fw9">薪资：</span>{{ item.salary }}
                  </div>
                </div>
                <div style="display: flex">
                  <div style="display: inline-block; width: 40vw">
                    <span class="fw9">需求专业：</span>{{ item.major }}
                  </div>
                  <span style=""
                    ><span class="fw9">工作地点：</span
                    >{{ item.workPlace }}</span
                  >
                </div>
                <div class="fw9">岗位描述：</div>
                <p style="white-space: pre-wrap">{{ item.positionsInfo }}</p>
                <div class="fw9">任职要求：</div>
                <p style="white-space: pre-wrap">
                  {{ item.positionsRequirements }}
                </p>
                <!-- <div class="fw9">笔试地址：</div> -->
                <!-- <a class="fw9" style="color:#42a5ec" :href="item.writtenExaminationUrl" target="_blank">笔试地址</a> -->
             <div>
                    <a
                    v-if="item.writtenExaminationUrl"
                      class="fw9" style="
                    display: inline-block;
                    background-color: rgba(35, 110, 235, 1);
                    color: #fff;
                    height: 30px;
                    line-height: 30px;
                    padding: 0 12px;
                    font-size: 16px;
                    border-radius: 6px;
                    cursor: pointer;
                      " :href="item.writtenExaminationUrl" target="_blank">笔试地址</a>
                  </div> 
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
        <div v-else>暂无职位~</div>
      </div>
      <div class="title-img" id="flow" style="margin: 180px auto">
        <img
          style="width: 1300px; height: 390px"
          src="@/assets/img/pc/FAQ-img.png"
          alt=""
        />
      </div>
    </div>
    <Footer showBackgroundColor></Footer>
    <el-dialog
      :close-on-click-modal="false"
      title="投递简历"
      :visible.sync="isShow"
      v-if="isShow"
      width="80%"
      append-to-body
    >
      <Form @hidden="isShow = false" ref="jobForm"></Form>
    </el-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import NavBar from "@/components/NavBar.vue";
import Footer from "@/components/Footer.vue";
import { isMobile } from "@/assets/js/index";
import Form from "./form.vue";
import { BASE_URL, LIST } from "@/service/api";

export default {
  name: "page3",
  components: {
    NavBar,
    Footer,
    Form,
  },
  data() {
    return {
      isShow: false,
      jobList: [],
      activeNames: -1,
    };
  },
  async mounted() {
    if (isMobile()) {
      this.$router.replace({ name: "mobile" });
    } else {
      const data = await fetch(BASE_URL + LIST, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      }).then((rsp) => rsp.json());
      this.jobList = data;
    }
  },
  methods: {
    show(index) {
      console.log(index);
      this.isShow = true;
      setTimeout(() => {
        this.$refs.jobForm?.updatePosition(this.jobList[index]);
      }, 100);
    },
  },
};
</script>
<style scoped>
.title-img {
  margin: 40px 0;
}
.job-box {
  font-size: 16px;
}
/deep/ .el-collapse-item__arrow {
  display: none;
}
.fw9 {
  font-weight: 900;
}
</style>
